import {ReactNode} from 'react';
import {Link, view} from '@sail/ui';
import {createViewConfig} from '@sail/engine';
import type {View} from '@sail/engine';
import type {Href} from '@sail/ui';
import {styles} from 'mkt-ssr/components/sail/SiteFooterSection/SiteFooterListStyles';

export type SiteFooterListItemProps = View.IntrinsicElement<
  'div',
  {
    /**
     * The content to be displayed inside the SiteFooterListItem
     */
    label: ReactNode;
    /**
     * The url to which this list item link should navigate
     */
    href?: Href;
    /**
     * The ID used to track interactions with this list item
     */
    ['data-analytics-label']?: string;
    /**
     * The ID used to identify this list item in tests
     */
    testId?: string;
  }
>;

// eslint-disable-next-line @stripe-internal/stripe/no-mixed-react-exports
export const SiteFooterListItemConfig = createViewConfig({
  props: {} as SiteFooterListItemProps,
  name: 'SiteFooterListItem',
});

/**
 * Renders an individual list item in the footer for stripe.com
 */
export const SiteFooterListItem = SiteFooterListItemConfig.createView(
  ({label, href, 'data-analytics-label': analyticsLabel, testId}) => {
    if (href) {
      return (
        <li>
          <Link
            href={href}
            data-analytics-label={analyticsLabel}
            data-testid={testId}
          >
            {label}
          </Link>
        </li>
      );
    }

    return (
      <view.li uses={[styles.nonLinkItem]} data-testid={testId}>
        {label}
      </view.li>
    );
  },
);
